import config from "environment";
import { getRequest, postRequest } from "./client";
import { ReportCardItem, Collection } from "winslow-core";
import {
  apiRunReportCardItemsPayload,
  apiFlagReportCardItemPayload,
} from "./ReportCardService.types";

const { baseApi } = config;

export async function apiGetReportCardItemsForCollection(
  collectionId: string
): Promise<ReportCardItem[] | null> {
  const fetchURL = `${baseApi}/report-card/${collectionId}`;
  return await getRequest(fetchURL, "API/apiGetReportCardItemsForCollection");
}

export async function apiCreateReportCardItemsForCollection(
  collectionId: string
): Promise<ReportCardItem[] | null> {
  const fetchURL = `${baseApi}/report-card/create/${collectionId}`;
  return await getRequest(
    fetchURL,
    "API/apiCreateReportCardItemsForCollection"
  );
}

export async function apiRunReportCardItems(
  payload: apiRunReportCardItemsPayload
): Promise<ReportCardItem[] | null> {
  const fetchURL = `${baseApi}/report-card/run/items`;
  return await postRequest(fetchURL, payload, "API/apiRunReportCardItems");
}

export async function apiFlagReportCardItem(
  payload: apiFlagReportCardItemPayload
): Promise<ReportCardItem | null> {
  const fetchURL = `${baseApi}/report-card/flag-item`;
  return await postRequest(fetchURL, payload, "API/apiFlagReportCardItem");
}
